export default function getResource(label, vars = []) {
    const resources = {
        copy: `Vous économisez <b>${vars[0]}</b> de plus avec <b>${vars[1]}</b>. En vigueur sur les commandes de réapprovisionnement automatique admissibles dont l’expédition est prévue entre le <b>${vars[2]}</b> et le <b>${vars[3]}</b>.`
    };

    return resources[label];
}
